import { render, staticRenderFns } from "./social-media.vue?vue&type=template&id=1bdef26f"
import script from "./social-media.vue?vue&type=script&lang=js"
export * from "./social-media.vue?vue&type=script&lang=js"
import style0 from "./social-media.vue?vue&type=style&index=0&id=1bdef26f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports